<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <Info></Info>
    <div class="currency_boxs confirm_box">
      <div class="order_info">
        <div class="font20 title">确认订单信息</div>
        <div class="info">
          <div class="info_title font16">购买订单信息</div>
          <div class="flexStart">
            <div class="left">
              <el-image style="width:186px; height: 108px;"
                        :src="url"></el-image>
              <div style="flex:1;margin-left:20px;color: #666666;">
                <div class="font18"
                     style="color:#333;position: absolute;top: 20px;left: 226px;">零售视界年度会员</div>
                <div class="font16">一年畅学平台400+课程</div>
                <div class="font16">有效期：2023年10月30日</div>
              </div>
            </div>
            <div class="right font20">￥999.00</div>
          </div>
        </div>
        <div class="font20 title">支付方式</div>

        <div>
          <div>微信支付</div>
        </div>
      </div>
      <!--  -->
      <div class="bottom">
        <div class="flexStart">
          <div class="font16"
               style="color:#666666">课程原价：￥999.00</div>
          <div style="flex:1"
               class="flexEnd">
            <div class="font20 price">应支付：￥999.00</div>
            <el-button type="danger"
                       @click="subPay">立即支付</el-button>
          </div>
        </div>

      </div>
    </div>
    <WechatPay ref="WechatPay"
               v-if="isWechatPay"
               @wechatPaySuccess="wechatPaySuccess"
               @orderStatusClose="orderStatusClose"
               @close="isWechatPay = false"></WechatPay>
  </div>
</template>

<script>
import Info from './components/info.vue'
export default {
  components: { Info },
  data () {
    return {
      isWechatPay: false,
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
    }
  },
  created () {

  },
  methods: {
    subPay () {
      this.isWechatPay = true;
      this.$nextTick(() => {
        this.$refs.WechatPay.creatQrCode('text', this.url);
      });
    },
    // 订单状态关闭 15分钟超时
    orderStatusClose () {
      this.isWechatPay = false;
      this.$Message.error({
        background: true,
        content: "订单超时, 请重新支付!",
      });
    },
    // 支付成功
    wechatPaySuccess () {
      this.isWechatPay = false;
      this.$Message.success({
        background: true,
        content: "支付成功!",
      });
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  // min-height: 100vh;
  background-color: #f5f5f5;
  .confirm_box {
    padding: 30px 0 60px 0;
    box-sizing: border-box;
    .bottom {
      margin-top: 30px;
      padding: 34px 30px;
      background-color: #fff;
      .price {
        font-family: 'bb';
        color: #de1f26;
        margin-right: 20px;
      }
    }
    .order_info {
      background-color: #fff;
      width: 100%;
      padding: 40px 30px;
      box-sizing: border-box;
      .title {
        color: #333;
        font-weight: bold;
      }
      .info {
        margin: 40px 0;
        .info_title {
          color: #999999;
          padding: 12px 20px;
          box-sizing: border-box;
          background-color: #f6f6f6;
        }
        .flexStart {
          border: 1px solid #e5e5e5;
          position: relative;
          .left {
            flex: 1;
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            // height: 108px;
            align-items: flex-end;
          }
          .right {
            border-left: 1px solid #e5e5e5;
            padding: 0 40px;
            color: #de1f26;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>
